import React from "react";
import Select, { components } from "react-select";
import { GoSearch, GoPlus, GoX } from "react-icons/go";
import { FOOD_LABEL, getAllRecipes, getIngredients } from "../../helpers";

const PLACEHOLDER_TEXT = "Search/add new items...";

const RecipeControl = ({ children, ...props }) => (
  <components.Control {...props}>
    <GoSearch className="ml-3 text-neutral-500" />
    {children}
  </components.Control>
);

const RecipeOption = ({ data: { metadata }, selectProps: { onSelect } }) => {
  const selectCallback = React.useCallback(() => {
    onSelect(metadata);
  }, [onSelect, metadata]);
  return (
    <div
      className="flex items-center p-4 hover:bg-gray-300 group"
      onClick={selectCallback}
    >
      <img
        className="h-auto w-8"
        src={metadata.icon}
        alt={metadata.name}
        title={metadata.name}
      />
      <p className="flex flex-1 flex-col min-w-0 mx-2">
        <span className="flex items-start flex-col font-semibold text-sm md:items-center md:flex-row">
          {metadata.isFood && (
            <span className="uppercase text-xs text-white font-bold mr-1 bg-orange-500 rounded-sm px-2 py-px">
              {FOOD_LABEL}
            </span>
          )}
          <span className="mr-1">{metadata.name}</span>
          <span className="flex items-end flex-wrap justify-center">
            {metadata.isFood &&
              getIngredients(metadata.id).map((ingredient) => (
                <React.Fragment key={ingredient.id}>
                  <img
                    className="w-5"
                    src={ingredient.icon}
                    alt={ingredient.name}
                    title={ingredient.name}
                  />
                  <GoX className="last:hidden mb-1 mx-1 w-3 h-3" />
                </React.Fragment>
              ))}
          </span>
        </span>
        <span className="text-xs truncate text-neutral-500">
          {metadata.desc}
        </span>
      </p>
      <button className="bg-blue-400 p-2 rounded-full text-white font-semibold text-lg group-hover:bg-blue-300">
        <GoPlus className="w-4 h-4" />
      </button>
    </div>
  );
};

export default function RecipeSelect({ onSelect, filterOptions }) {
  const recipeOptions = React.useMemo(() => {
    return getAllRecipes()
      .filter((recipe) => !filterOptions.find((o) => o.id === recipe.id))
      .map((recipe) => ({
        metadata: recipe,
        label: recipe.name,
        value: recipe.id,
      }));
  }, [filterOptions]);

  return (
    <Select
      className="text-left"
      blurInputOnSelect
      placeholder={PLACEHOLDER_TEXT}
      closeMenuOnSelect={false}
      options={recipeOptions}
      components={{ Option: RecipeOption, Control: RecipeControl }}
      onSelect={onSelect}
    />
  );
}
